import { ReactSketchCanvas } from "react-sketch-canvas";
import { useRef, useState } from "react";
import { HexColorPicker } from "react-colorful";
import SvgPen from "../../../icons/SvgPen";
import Eraser from "../../../assets/eraser.svg";
import SvgUndo from "../../../icons/SvgUndo";
const WhiteboardView = () => {
  //Define a refernce for the canvas
  const canvasRef = useRef();
  const [showPicker, setShowPicker] = useState(false);
  const [color, setColor] = useState("#4e45ff");
  const [eraseMode, setEraseMode] = useState(false);

  //Define the props required by the canvas element used
  const canvasProps = {
    width: "100%",
    height: "100%",
    backgroundImage:
      "https://upload.wikimedia.org/wikipedia/commons/7/70/Graph_paper_scan_1600x1000_%286509259561%29.jpg",
    preserveBackgroundImageAspectRatio: "none",
    strokeWidth: 4,
    eraserWidth: 40,
    canvasColor: "#FFFFFF",
    allowOnlyPointerType: "all",
    withViewBox: false,
  };

  const handleEraserClick = () => {
    setEraseMode(true);
    canvasRef.current?.eraseMode(true);
  };

  const handlePenClick = () => {
    setEraseMode(false);
    canvasRef.current?.eraseMode(false);
  };

  const handleUndoClick = () => {
    canvasRef.current?.undo();
  };

  const handleRedoClick = () => {
    canvasRef.current?.redo();
  };

  return (
    <div className="flex h-full [@media(max-width:1086px)]:h-[60vh]">
      <div
        onClick={() => setShowPicker(false)}
        className="w-full overflow-hidden"
      >
        <ReactSketchCanvas
          ref={canvasRef}
          {...canvasProps}
          strokeColor={color}
        />
      </div>
      <div className={`${showPicker ? "w-[200px]" : "w-[40px]"}`}>
        {!showPicker ? (
          <div className="ml-2">
            <div
              onClick={() => setShowPicker(true)}
              className="w-8 h-8 rounded-full cursor-pointer"
              style={{ backgroundColor: color }}
            ></div>

            <button
              onClick={handlePenClick}
              className={`w-8 h-8 rounded-[10px] mt-4 ${
                eraseMode ? "bg-[#a1a1a1]" : "bg-pri"
              } flex items-center justify-center`}
            >
              <SvgPen currentColor={"#ffffff"} stroke />
            </button>

            <button
              onClick={handleEraserClick}
              className={`w-8 h-8 rounded-[10px] mt-4 ${
                !eraseMode ? "bg-[#a1a1a1]" : "bg-pri"
              } flex items-center justify-center`}
            >
              <img src={Eraser} alt="" />
            </button>

            <button
              onClick={handleUndoClick}
              className={`w-8 h-8 rounded-[10px] mt-4 bg-[#a1a1a1] flex items-center justify-center`}
            >
              <SvgUndo />
            </button>

            <button
              onClick={handleRedoClick}
              className={`w-8 h-8 rounded-[10px] mt-4 bg-[#a1a1a1] flex items-center justify-center rotate-180`}
            >
              <SvgUndo />
            </button>
          </div>
        ) : (
          <HexColorPicker color={color} onChange={setColor} />
        )}
      </div>
    </div>
  );
};

export default WhiteboardView;
